import { render } from "./ChoosableFeature.vue?vue&type=template&id=5d1e9fc6&scoped=true"
import script from "./ChoosableFeature.vue?vue&type=script&lang=js"
export * from "./ChoosableFeature.vue?vue&type=script&lang=js"

import "./ChoosableFeature.vue?vue&type=style&index=0&id=5d1e9fc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1e9fc6"]])

export default __exports__